import type { BusinessIssueField } from '@atlassian/jira-business-entity-project/src/services/issue-types-and-fields/types.tsx';

const SUPPORTED_STATISTIC_FIELD_TYPES = [
	'com.atlassian.jira.plugin.system.customfieldtypes:select',
	'com.atlassian.jira.plugin.system.customfieldtypes:float',
	'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
	'com.pyxis.greenhopper.jira:jsw-story-points',
	'assignee',
	'reporter',
	'status',
	'priority',
	'issuetype',
];

export const filterStatisticFields = (fields: BusinessIssueField[]): BusinessIssueField[] => {
	return fields.filter(
		(field) =>
			field.__typename === 'JiraNumberField' ||
			(field.type && SUPPORTED_STATISTIC_FIELD_TYPES.includes(field.type)),
	);
};
